











import { Vue, Component, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { mapState } from "vuex";
import { IAccount } from "@/models/accounts";
@Component({
  components: {
    "wallet-transactions-table": () =>
      import("@/components/app/global/wallets/walletTransactionsTable.vue")
  },
  computed: {
    ...mapState({
      transactionsDataScope(state, getters) {
        return getters[`data/${DataModules.WALLETS}/transactionsListScope`](
          this.accountId
        );
      }
    })
  }
})
export default class WalletTransactionsModal extends Vue {
  @Prop({ default: "" })
  public accountId!: IAccount["id"];
}
